"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const react_1 = require("react");
/*
Instantiates a useEffect that listens for the snowplow tracker to be ready
*/
const useSnowplowListener = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const [snowplow, setSnowplow] = (0, react_1.useState)(window.snowplow);
    (0, react_1.useEffect)(() => {
        const handleSnowplow = () => {
            setSnowplow(window.snowplow);
        };
        (0, snowplow_js_common_1.addSnowplowTrackerReadyEventListener)(handleSnowplow);
        return () => {
            (0, snowplow_js_common_1.removeSnowplowTrackerReadyEventListener)(handleSnowplow);
        };
    }, []);
    return snowplow;
};
exports.default = useSnowplowListener;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU25vd3Bsb3dMaXN0ZW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTbm93cGxvd0xpc3RlbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUVBR2tDO0FBRWxDLGlDQUE0QztBQUU1Qzs7RUFFRTtBQUNGLE1BQU0sbUJBQW1CLEdBQUcsR0FBK0IsRUFBRTtJQUN6RCxJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsRUFBRTtRQUMvQixPQUFPLFNBQVMsQ0FBQztLQUNwQjtJQUVELE1BQU0sQ0FBQyxRQUFRLEVBQUUsV0FBVyxDQUFDLEdBQUcsSUFBQSxnQkFBUSxFQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUUxRCxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsTUFBTSxjQUFjLEdBQUcsR0FBUyxFQUFFO1lBQzlCLFdBQVcsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUM7UUFDakMsQ0FBQyxDQUFDO1FBRUYsSUFBQSx5REFBb0MsRUFBQyxjQUFjLENBQUMsQ0FBQztRQUVyRCxPQUFPLEdBQUcsRUFBRTtZQUNSLElBQUEsNERBQXVDLEVBQUMsY0FBYyxDQUFDLENBQUM7UUFDNUQsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxRQUFRLENBQUM7QUFDcEIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsbUJBQW1CLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useSnowplowListener.ts